import { useAppDataContext } from '_CONTEXT/hook/contextHook'
import { appDataStore } from '_STORES/AppData'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { translate } from 'translation'

const SaveSettinsButton = () => {

    const { saveParameters } = useAppDataContext()
    const isDirty = appDataStore.isDirty

    return (
        <form onSubmit={e =>
            saveParameters(e, true)
        }>
            <button
                className={`strong-button ${isDirty ? 'dirty' : ''}`}
                disabled={!isDirty}
            >
                {translate("Save settings")}
            </button>
        </form>)
}

export default observer(SaveSettinsButton)